
import React from 'react';
import { Card } from '@/components/ui/card';
import { TransportationDetails } from '@/types/itinerary';
import JourneyCardHeader from './card/JourneyCardHeader';
import JourneyCardContent from './card/JourneyCardContent';

interface JourneyCardProps {
  id?: string;
  icon: React.ReactNode;
  title: string;
  details: TransportationDetails;
  handleChange: (field: string, value: any) => void;
  saveDetails: () => void;
  saveButtonText: string;
  isAuthorized: boolean;
}

const JourneyCard: React.FC<JourneyCardProps> = ({ 
  id,
  icon, 
  title, 
  details, 
  handleChange, 
  saveDetails, 
  saveButtonText,
  isAuthorized
}) => {
  return (
    <Card id={id}>
      <JourneyCardHeader icon={icon} title={title} />
      <JourneyCardContent
        isAuthorized={isAuthorized}
        details={details}
        handleChange={handleChange}
        saveDetails={saveDetails}
        formTitle={title}
        saveButtonText={saveButtonText}
      />
    </Card>
  );
};

export default JourneyCard;
